<template>
  <v-hover>
    <v-card
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 2}`"
      class="mx-auto c-click"
      @click.native="onClick"
    >
      <div class="c-msg-json">
        <div class="flex-col-left">
          <div>{{ $T('common.registered', { tgt: $utils.postCodeToName(data.type) }) }}</div>
          <div class="flex-row-left c-tile">
            <div class="flex-row c-tile-icon">
              <v-icon color="black" :size="26">{{ $utils.postCodeToIcon(data.type) }}</v-icon>
            </div>
            <div class="c-tile-title">
              {{ $utils.postToTitle(post) }}
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-hover>
</template>

<script>
import CacheUtils from '../../utils/CacheUtils';
import CommunityPostApi from '../../api/post';

export default {
  props: {
    tid: { type: Number, required: true },
    /*
      export interface TalkMsgForPost {
        t: TALK_MSG_TYPE.POST;
        type: POST_TYPE;
        pid: number;
      }
    */
    data: { type: Object, required: true },
    maxWidth: { type: Number, required: true },
  },
  data() {
    const w = Math.min(this.maxWidth / 2, 80);
    return {
      post: null,
      serverRequested: false,
    };
  },
  created() {
    (async () => {
      const pid = this.data.pid;

      const p = await CacheUtils.getPost(pid);
      if (p) {
        this.post = p;
        return;
      }

      const post = await CommunityPostApi.getPost(pid);
      if (post) {
        CacheUtils.setPost(pid, post);
        this.post = post;
      }
      this.serverRequested = true;
    })();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    onClick() {
      this.$router.push({ name: 'postDetail', params: { id: this.curCid, pid: this.data.pid } });
    },
  },
};
</script>

<style scoped>
.c-click {
  cursor: pointer;
  cursor: hand;
}
.c-tile {
  padding-top: 5px;
}
.c-tile-icon {
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
.c-tile-title {
  font-size: 14px;
  font-weight: 600;
}
</style>
